export default __webpack_public_path__ + "static/media/plus_design.66c638d6.png";